module.exports = __webpack_public_path__ + "img/西瓜11.dce7da18.png";